import { render, staticRenderFns } from "./BorrowedTutus.vue?vue&type=template&id=09a28bc3"
import script from "./BorrowedTutus.vue?vue&type=script&lang=js"
export * from "./BorrowedTutus.vue?vue&type=script&lang=js"
import style0 from "./BorrowedTutus.vue?vue&type=style&index=0&id=09a28bc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports